var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.766,
    height: 95.762,
    viewBox: "0 0 95.766 95.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.08 -0.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Copy",
    transform: "translate(-895 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto---B",
    transform: "translate(895.08 279.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-10",
    d: "M92.607.009a3.015,3.015,0,0,1,3.15,3.15C95.546,5.6,92.514,60.954,74.8,78.671c-16.978,16.978-36.986,12.995-50.051,3.6-.158-.114-.335-.25-.53-.406L12.439,93.629a7.286,7.286,0,0,1-10.3-10.3L13.9,71.549q-.237-.3-.408-.532C4.1,57.954.114,37.947,17.093,20.966,34.81,3.249,90.171.215,92.607.009Z",
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M52.077,67.261c8.933,0,14.473-4.612,14.473-11.979,0-5.54-4.177-9.687-9.861-10.122v-.232a9.232,9.232,0,0,0,7.86-9.078c0-6.41-4.931-10.441-12.791-10.441H37.923c-2.755,0-4.38,1.682-4.38,4.554V62.678c0,2.9,1.624,4.583,4.38,4.583ZM48.6,42.811H42.3V31.934H49.5c4.09,0,6.439,1.914,6.439,5.279C55.935,40.751,53.266,42.811,48.6,42.811Zm1.247,17.924H42.3V48.582h7.338c5.163,0,7.976,2.088,7.976,6C57.617,58.589,54.891,60.735,49.844,60.735Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafB);
export default __webpack_public_path__ + "static/media/LeafB.2e4f3fa474e5ac933ec51e3433c3afa6.svg";
export { ForwardRef as ReactComponent };